import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AlertService } from 'src/app/_alert';
import { AuthService } from 'src/app/_services/auth.service';
import { LoginService } from 'src/app/_services/login.service';
import { PaymentService } from 'src/app/_services/payment.service';
import { CreateTransactionViewModel } from 'src/app/models/createTransactionModel';
import { ConfirmBoxCreatePaymentComponent } from '../confirm-box-create-payment/confirm-box-create-payment.component';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-confirm-create-payment',
  templateUrl: './confirm-create-payment.component.html',
  styleUrls: ['./confirm-create-payment.component.css'],
  providers : [DatePipe]
})
export class ConfirmCreatePaymentComponent implements OnInit {
  submitted: boolean = true;
  options = {
    autoClose: true,
    keepAfterRouteChange: true,
  };

  constructor(public dialog: MatDialog,
    public dialogRef: MatDialogRef<ConfirmCreatePaymentComponent>,
    @Inject(MAT_DIALOG_DATA) public data: CreateTransactionViewModel,
    private loginService: LoginService,
    private authService: AuthService,
    private paymentService: PaymentService,
    private alertService: AlertService,
    private datePipe : DatePipe) { }

  ngOnInit(): void {
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  openDialog(): void {
    const dialogRef = this.dialog.open(ConfirmBoxCreatePaymentComponent, {
      width: '500px',
      disableClose: true
    });
  }
  

  onSubmit() {
    this.submitted = true;
    //this.data.ServiceDate  = this.datePipe.transform(this.data.ServiceDate, 'MM/dd/yyyy');
    // this.data.ServiceDate  = this.datePipe.transform(this.data.ServiceDate, 'MM/dd/yyyy');
    this.paymentService.createTransaction(this.data)
      .subscribe((response) => {
        console.log(response);
        this.alertService.success('Success!!Data Saved SuccessFully.', this.options);
        this.openDialog()
      }, (err) => {
        console.log(err);
        this.alertService.error(err.error.errors.Messages[0], this.options);
        this.alertService.error(err.error.errors.title, this.options);
        this.alertService.error(err.error.responseDescription, this.options);
        
      })
  }
}
